import { UserRole } from 'shared/types/userRole';
import { PermissionManagerFactory } from '../permissionManagerFactory';
import { PermissionConfig } from '../types';

const CREATE_ISSUE_PERMISSIONS: PermissionConfig = {
  [UserRole.superAdmin]: true,
  [UserRole.organizationAdmin]: true,
  [UserRole.projectAdmin]: true,
  [UserRole.manager]: true,
  [UserRole.viewer]: true,
  [UserRole.standard]: true,
  [UserRole.visible_no_access]: false,
};

const EDIT_ISSUE_PERMISSIONS: PermissionConfig = CREATE_ISSUE_PERMISSIONS;

const DELETE_ISSUE_PERMISSIONS: PermissionConfig =
  CREATE_ISSUE_PERMISSIONS;

export const IssuePermissionManager = PermissionManagerFactory.create({
  permissionConfigForCreate: CREATE_ISSUE_PERMISSIONS,
  permissionConfigForEdit: EDIT_ISSUE_PERMISSIONS,
  permissionConfigForDelete: DELETE_ISSUE_PERMISSIONS,
});
